import React from 'react';

import { SimpleTitleComponentFragment } from '../../../../graphql.schema';
import { ContentBlock } from '../../ContentBlock/ContentBlock';

import * as styles from '../index.module.scss';

export const StrapiSimpleTitleComponent: React.FC<SimpleTitleComponentFragment> = (props) => {
  return (
    <div className={styles.simpleTitle}>
      <ContentBlock title={props.title} titleClass="is-2" content={props.intro ?? undefined} />
    </div>
  );
};
